$(document).on("change", ".address_dropdown", function () {
  var selected_val = $(this).val();
  if (selected_val == "") {
    //   	$('.address_form').css('display', 'none');
    $(".address1").val("");
    $(".address2").val("");
    $(".address3").val("");
    $(".town").val("");
    $(".county").val("");
    $(".post_code").val("");
  } else {
    selected_val = selected_val.replace(/[#]/g, " ");
    selected_val = JSON.parse(selected_val);
    //     $('.address_form').css('display', 'block');
    $(".address1").val(
      selected_val.line_1.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      })
    );
    $(".address2").val(
      selected_val.line_2.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      })
    );
    $(".address3").val(
      selected_val.line_3.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      })
    );
    $(".town").val(
      selected_val.town.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      })
    );
    $(".county").val(
      selected_val.postal_county
        .toLowerCase()
        .replace(/\b[a-z]/g, function (letter) {
          return letter.toUpperCase();
        })
    );
    $(".post_code").val(selected_val.postcode);

    var inputEvent = new Event("input", {
      bubbles: true,
      cancelable: true,
    });

    elems = document.querySelectorAll(
      ".address1, .address2, .address3, .town, .county, .post_code"
    );

    for (var i = 0; i < elems.length; i++) {
      elems[i].dispatchEvent(inputEvent);
    }
  }
});

$(document).ready(function () {
  $("#ContactForm").submit(function (e) {
    e.preventDefault();

    $(".submit_btn").prop("disabled", true);
    $(".submit_btn").attr("value", "Please Wait");
    var form_data = $("#ContactForm").serializeArray();
    var urlpost =
      "https://apps.cedcommerce.com/marketplace-integration/fba/rm-order/save-data";
    var request_form_name = "";
    form_data.forEach(function (index) {
      if (index.value == "Order Pack Form") {
        request_form_name = "Ashes Collection Packs";
      }
      if (index.value == "Brochure Form") {
        request_form_name = "Brochures";
      }
      if (index.name == "contact[order form]") {
        request_form_name = "Brochures and Ashes Collection Packs";
      }
    });
    $(".requested_form_name").html(request_form_name);
    $.ajax({
      method: "post",
      url: urlpost,
      data: form_data,
      dataType: "json",
      complete: function (msg) {
        //         $('.success_address').html('Thanks for your submission');
        $(".ced_Custom_Popup").css("display", "flex");
        $(".submit_btn").prop("disabled", false);
        $(".submit_btn").attr("value", "Submit");
        $("#ContactForm")[0].reset();
        $(".dropdown-wrapper").remove();
        $(".address_dropdown").remove();
      },
    });
  });
  $(".start_typing_btn").attr("disabled", true);
  $(".start_typing").on("input", function () {
    var value_field = $(this).val().replace(/^\s+/g, "");
    if (value_field.length != 0) $(".start_typing_btn").attr("disabled", false);
    else $(".start_typing_btn").attr("disabled", true);
  });
});

//Function for validate Postcode
function validatePostCode(indentifier) {
  var postcode = $(".start_typing").val();
  var api_url =
    "https://pcls1.craftyclicks.co.uk/json/rapidaddress?key=704a6-635ee-5c265-02884&postcode=" +
    postcode +
    "&response=data_formatted&lines=3";
  $.ajax({
    url: api_url,
    contentType: "application/json",
    dataType: "json",
    success: function (result) {
      if (!result.error_code) {
        var address = result.delivery_points;
        //             $('.address_form').css('display','none');
        if ($(".dropdown-wrapper").length > 0) {
          $(".dropdown-wrapper").remove();
        }
        if ($(".address_dropdown").length > 0) {
          $(".address_dropdown").remove();
        }
        var html =
          '<div class="dropdown-wrapper"><select required="required" class="address_dropdown"><option value="">Please select address</option>';
        $(address).each(function (index, element) {
          var option_add = "";
          if (element.department_name != "") {
            option_add += element.department_name + " ";
          }
          if (element.organisation_name != "") {
            option_add += element.organisation_name + " ";
          }
          if (element.line_1 != "") {
            option_add += element.line_1 + " ";
          }
          if (element.line_2 != "") {
            option_add += element.line_2 + " ";
          }
          if (element.line_3 != "") {
            option_add += element.line_3 + " ";
          }
          if (element.town != "") {
            option_add += result.town + " ";
          }
          if (element.postal_county != "") {
            option_add += result.postal_county + " ";
          }
          if (element.postcode != "") {
            option_add += result.postcode;
          }
          element.town = result.town;
          element.postal_county = result.postal_county;
          element.postcode = result.postcode;
          var attr = JSON.stringify(element);
          attr = attr.replace(/ /g, "#");
          html += "<option value=" + attr + ">" + option_add + "</option>";
        });
        html += "</select></div>";
        $("." + indentifier).after(html);
      } else {
        if ($(".address_dropdown").length > 0) {
          $(".address_dropdown").remove();
          $(".address1").val("");
          $(".address2").val("");
          $(".address3").val("");
          $(".town").val("");
          $(".county").val("");
          $(".post_code").val("");
        }
        var html =
          '<span class="address_dropdown">The postcode is not valid, please try again or enter your address manually</span>';
        $("." + indentifier).after(html);
        //             $('.address_form').css('display','block');
      }
    },
  });
}
